import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme)=> ({
    label: {
        width: "30%",
        fontSize: "14px",
        lineHeight: "36px"
    },
    value: {
        width: '70%'
    },
    row: {
        marginBottom: theme.spacing(1.5)
    },
    divider: {
        margin: theme.spacing(1, 0)
    },
    compositeConditionRow: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: theme.shape.borderRadius,
        backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[200],
        overflow: 'hidden',
        minHeight: 32,
        maxHeight: 32,
        position: 'relative',
        zIndex: 1
    },
    compositeConditionText: {
        flex: 1,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: 14,
        lineHeight: '32px',
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1)
    },
    compositeConditionActions: {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        height: 32,
        maxHeight: 32,
        boxSizing: 'border-box',
        borderLeft: `1px solid ${theme.palette.divider}`,
        paddingLeft: theme.spacing(0.25),
        paddingRight: theme.spacing(0.25),
        '& .MuiIconButton-root': {
            padding: theme.spacing(0.5)
        }
    }
}))